import React, { useRef, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { addDeliveryOrder, removeDeliveryOrder, addSizes, showSizes, addStock } from '../../store/actions/index'
import { Dropdown, Form, Button, FormControl, Row, Col, ListGroup, OverlayTrigger } from 'react-bootstrap'
import { CustomMenu, CustomToggle } from '../presentational-components/simple-objects/CustomDropDown'
import MaintainStockList from './MaintainStockList'
import '../../index.css'
import SizesControl from './SizesControl'
import { sizeValues } from './SizesControl'
import { FetchTransactionInfos, FetchArticleTypeImages, FetchDesigners } from '../../fetcher'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import AlertMessage from '../presentational-components/AlertMessage'
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import { RenderImage } from '../presentational-components/ImageViewer'
import { SimpleDateSelect } from '../presentational-components/FilterComponents'
import moment from 'moment'

let numberInputs = []
let sizeCategory
let articleEntry
let articleSysId
let articleIdFaex
let articleNumberDesigner
let salePrice
let designerName
let image
let articleDropdown

//focusFirstItemOnShow='keyboard' onClick={setFocusOnFilter}

const MaintainStock = ({ dispatch, handleCloseMask, transactionType = "NewArrivals", reloadParent, draft = null }) => {
    const [articles, setArticles] = useState([])
    const [sizeCats, setSizeCats] = useState([])
    const articleHeaderDefault = "Artikeltyp auswählen"
    const [articleNameHeader, setArticleNameHeader] = useState(articleHeaderDefault)
    const designerHeaderDefault = "Designer auswählen"
    const [designerNameHeader, setDesignerHeader] = useState(designerHeaderDefault)
    const [uiError, setError] = useState(false)

    const [addToStock, setAddToStock] = useState([])
    const [remark, setRemark] = useState("")
    const [isDraftUpdate, setIsDraftUpdate] = useState(false)
    const [transactionDate, setTransactionDate] = useState(draft !== null ? draft.TransactionDate : moment(Date.now()).format("DD.MM.YYYY"))
    const [transactionNumber, setTransactionNumber] = useState(draft !== null ? draft.TransactionNumber : "")

    const [isFaexStorage, setIsFaexStorage] = useState(false)
    const [designers, setDesigners] = useState([])
    const [designerSelection, setDesignerSelection] = useState("")

    const [articleDropDownShow, setArticleDropDownShow] = useState(false)

    const [designerFilterInput, setDesignerFilterInput] = useState("")
    const handleDesignerFilter = (e) => {
        setDesignerFilterInput(e.target.value)
    }

    const [articleFilterInput, setArticleFilterInput] = useState("")
    const handleArticleFilter = (e) => {
        setArticleFilterInput(e.target.value)
    }

    const handleSetDesignerSelection = (designer) => {
        setDesignerSelection(designer)
        setDesignerHeader(designer.Name)
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [articleDataReady, setArticleDataToReady] = useState(false)

    const [taskName, setTaskName] = useState("MaintainStock unbekannte Task")

    const addingImages = (articleTypeImages) => {
        let copiedArticleData = [...articles]
        articleTypeImages.forEach(image => copiedArticleData.find(x => x.Articles.ArticleTypeSysId == image.ArticleTypeSysId).Articles.Image = 'data:image/png;base64,' + image.Data)
        setArticles(copiedArticleData)
    }

    useEffect(() => {
        console.log("Component did mount: ", transactionType, draft)
        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setTaskName("Die Designers werden geladen")
            FetchDesigners(setDesigners, openAlert, "MaintainStockDesigner")
            setIsFaexStorage(true)
        }
    }, [])

    useEffect(() => {
        setTaskName("Die Verfügbarkeit der Artikel wird geladen")
        console.log("Component did mount: ", transactionType)

        FetchTransactionInfos(setArticles, setSizeCats, openAlert, setArticleDataToReady, () => console.log("MaintainStock ", articles), "MaintainStock")

        if (draft !== null) {
            console.log("draft !== null, ", draft)
            setRemark(draft.Remark)
            setTransactionNumber(draft.TransactionNumber)
            setTransactionDate(draft.TransactionDate)
            setIsDraftUpdate(true)

            let newAddStock = [...addToStock]

            draft.Articles.forEach(article => {
                if (newAddStock.find(x => x.sizeCat == article.SizeCat) == null)
                    newAddStock.push({ sizeCat: article.SizeCat, articleTypes: [] })
                if (newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId) == null)
                    newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.push({ articleName: article.Name, articleSysId: article.ArticleTypeSysId, articleIdFaex: article.ArticleIdFaex, articleNumberDesigner: article.ArticleNumberDesigner, salePrice: article.SalePrice, designerName: article.DesignerName, image: article.Image, sizeEntries: [] })
                article.Sizes.forEach(z =>
                (newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue) == null
                    ? newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.push({ SizeValue: z.SizeValue, Amount: parseInt(z.Amount) })
                    : newAddStock.find(x => x.sizeCat == article.SizeCat).articleTypes.find(x => x.articleSysId == article.ArticleTypeSysId).sizeEntries.find(x => x.SizeValue == z.SizeValue).Amount += parseInt(z.Amount)))
            }
            )

            setAddToStock(newAddStock)
        }
    }, []);

    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(articles.map(x => x.Articles.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    const setFocus = () => {
        articleDropdown.focus()
    }

    const handleChange = (e, article) => {
        if(e !== null) e.preventDefault()
        setArticleNameHeader(article != null ? article.Articles.Name : articleHeaderDefault)
        setArticleDropDownShow(false)

        if (article != null && article != undefined && article.Articles != undefined) {
            sizeCategory = article.SizeCat
            articleSysId = article.Articles.ArticleTypeSysId
            articleIdFaex = article.Articles.ArticleIdFaex
            articleNumberDesigner = article.Articles.ArticleNumberDesigner
            salePrice = article.Articles.SalePrice
            designerName = article.Articles.DesignerName
            image = article.Articles.Image
            dispatch(showSizes(article.Articles.Name, article.Articles.SizeValues))
        } else {
            sizeCategory = ""
            dispatch(showSizes("", []))
        }
    }

    const submitAddToStock = (e) => {
        e.preventDefault()

        if (sizeValues.some(x => parseInt(x.amount) != 0)) {
            let newStock = [...addToStock]

            if (newStock.find(x => x.sizeCat == sizeCategory) == null)
                newStock.push({ sizeCat: sizeCategory, articleTypes: [] })
            if (newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId) == null)
                newStock.find(x => x.sizeCat == sizeCategory).articleTypes.push({ articleName: articleNameHeader, articleSysId: articleSysId, articleIdFaex: articleIdFaex, articleNumberDesigner: articleNumberDesigner, salePrice: salePrice, designerName: designerName, image: image, sizeEntries: [] })
            sizeValues.forEach(z =>
            (newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue) == null
                    ? newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.push({ SizeValue: z.size.SizeValue, Amount: parseInt(z.amount) })
                : newStock.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue).Amount += parseInt(z.amount)))

            setAddToStock(newStock)

            //newStock: [ {sizeCat, [articleTypes {articleName, articleSysId, sizeEntries [{sizeValue, amount}] }] } ]
            //let entry = newStock.find(x => x.sizeCat == sizeCategory)
            //entry == null ? newStock.push({ sizeCat: sizeCategory, articleTypes: [{ articleName: nameHeader, articleSysId: articleSysId, sizeEntries: sizeValues.forEach(val => [{ sizeValue: val.size, amount: val.amount }] ) }] })
            //    : entry.sizeCat.articleTypes.find(x => x.articleSysId == articleSysId) == null ? newStock.find(x => x.sizeCat == articleType).articleTypes.push({ articleName: nameHeader, articleSysId: articleSysId, sizeEntries: sizeValues.forEach(val => [{ sizeValue: val.size, amount: val.amount }]) })
            //        : return

            handleChange(null, null)
            dispatch(showSizes("", []))
            setError(false)
        } else {
            setError(true)
        }

        setFocus()
    }

    const renderOrderInput = () => {
        return (
            <div className="form-inline order-input">
                <SizesControl />
                <Button variant="secondary" className="form form-inline order-input order-input-button" type="submit"> ✓ </Button>
            </div>
        )
    }

    const renderErrorMessage = () => {
        return (<div className="error">Mindestens ein Wert muss gesetzt sein.</div>)
    }

    const removeOrderEntry = (e, sizeCat, articleEntry) => {
        e.preventDefault()

        let removeFromStock = [...addToStock]

        removeFromStock.forEach(function (sizeCat) {
            sizeCat.articleTypes = sizeCat.articleTypes.filter(x => x.articleSysId != articleEntry.articleSysId)
        });
        removeFromStock = removeFromStock.filter(x => x.articleTypes.length > 0)

        setAddToStock(removeFromStock)
    }

    const resetOrderEntries = () => {
        setAddToStock([])
    }

    const handleDatePickerCallback = (start) => {
        console.log("DateRangePicker Start:")
        console.log(moment(start).format("DD.MM.YYYY"))
        setTransactionDate(moment(start).format("DD.MM.YYYY"));
    }

    const handleClearFilter = () => {
        setTransactionDate("")
    }

    return (
        <div>
            {/*<h1>Bestand pflegen</h1>*/}

            <Form>
                <Row>
                    <Col>
                        <Form.Control className="smallInput" size="sm" placeholder="Lieferscheinnummer" onChange={(e) => setTransactionNumber(e.target.value)} value={transactionNumber} />
                    </Col>
                    <Col>
                        {SimpleDateSelect(handleDatePickerCallback, handleClearFilter, transactionDate)}
                    </Col>
                </Row>
            </Form>

            <Form onSubmit={submitAddToStock}>

                <Dropdown className="form">
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-boutique" >
                        {designerNameHeader}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="article-dropdown">
                        <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Name Designer..." value={designerFilterInput} onChange={handleDesignerFilter}></FormControl>
                        {
                            designers.filter(x => x.Name.toLowerCase().includes(designerFilterInput.toLowerCase()))
                                .sort((a, b) => a.Name.localeCompare(b.Name))
                                .map(designer =>
                                <Dropdown.Item variant="secondary" className="listGroup-item" active={false} onSelect={() => handleSetDesignerSelection(designer)}>
                                    {designer.Name}
                                </Dropdown.Item>
                            )
                        }
                        <LoadingSpinner task={taskName} area={"MaintainStockDesigner"} />
                    </Dropdown.Menu>
                </Dropdown>

                <Dropdown className="form" >
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" ref={node => articleDropdown = node} >
                        {articleNameHeader}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="article-dropdown" >

                        <FormControl className="globalSearch-deliveryOrder" as="input" placeholder="Name Artikel..." value={articleFilterInput} onChange={handleArticleFilter}></FormControl>
                        
                            <div className="dropdown-listGroup">
                                {articles.filter(x => x.Articles.DesignerSysId == designerSelection.MandatorSysId /*&& x.SizeCat == sizeCat*/
                                    && (x.Articles.Name.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleNumberDesigner.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())
                                    || x.Articles.SalePrice.toString().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())))
                                    .sort((a, b) => a.Articles.Name.localeCompare(b.Articles.Name))
                                    .map(article =>

                                        <ListGroup.Item className="dropdown-listGroup-item" value={article.Articles.Name} action onClick={(e) => handleChange(e, article)}>
                                            <Dropdown.Item variant="secondary" className="listGroup-item" active={false}>
                                                <Row >
                                                    <Col className="dropdown-imageColumn">{RenderImage(article.Articles.Image)}</Col>
                                                    <Col >{article.Articles.Name}</Col>
                                                    <Col className="dropdown-article-smallField">{article.Articles.ArticleIdFaex}</Col>
                                                    <Col >{article.Articles.ArticleNumberDesigner}</Col>
                                                    <Col className="dropdown-article-smallField">{article.Articles.Colour}</Col>
                                                    <Col className="dropdown-article-smallField">{article.Articles.SalePrice}€</Col>
                                                    <OverlayTrigger trigger="hover" placement="top" overlay={DescriptionTooltip(article.Articles.DescriptionDesigner)}>
                                                        <Col className="dropdown-article-description">{article.Articles.DescriptionDesigner}</Col>
                                                    </OverlayTrigger>
                                                </Row>
                                            </Dropdown.Item>
                                        </ListGroup.Item>
                                    )
                                }
                            </div>                        

                        <LoadingSpinner task={taskName} area={"MaintainStock"} />
                        <Dropdown.Divider />
                    </Dropdown.Menu>
                </Dropdown >

                {articleNameHeader !== articleHeaderDefault ?
                    renderOrderInput() : <div className="placeholder">empty</div>
                }
                <div style={{ height: 40 }}></div>
                {uiError && renderErrorMessage()}

            </Form>

            <MaintainStockList removeOrderEntry={removeOrderEntry} addToStock={addToStock} transactionType={transactionType} remark={remark} resetOrderEntries={resetOrderEntries} handleCloseMask={handleCloseMask} reloadParent={reloadParent} isDraftUpdate={isDraftUpdate} draftSysId={draft !== null ? draft.TransactionSysId : null} transactionNumber={transactionNumber} transactionDate={transactionDate} />

            <Form className="remark-form">
                <Form.Group className="mb-3">
                    <Form.Label>Bemerkung zur Bestandsänderung</Form.Label>
                    <Form.Control as="textarea" defaultValue={draft !== null ? draft.Remark : ""} rows={3} onChange={(e) => setRemark(e.target.value)} />
                </Form.Group>
            </Form>

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

const testing = (showSizes) => {
    console.log("StateSizes: " + showSizes)
    return showSizes;
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps)(MaintainStock)